import { render, staticRenderFns } from "./VineyardProfile.vue?vue&type=template&id=41d27f81&scoped=true"
import script from "./VineyardProfile.vue?vue&type=script&lang=js"
export * from "./VineyardProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d27f81",
  null
  
)

export default component.exports